import React, { useState } from 'react';
import { Label } from 'reactstrap';
import '../assets/style/SearchBox.css';
import Select from 'react-select';
import '../assets/style/SelectBox.css';
import { SelectOptionType } from '../utils/Types';
interface ISelectBoxProps {
  options: any;
  label?: string;
  className?: string;
  value?: SelectOptionType;
  closeMenuOnSelect?: boolean;
  isMulti?: boolean;
  onChange?: (event: any) => void;
  customStyles?: any;
  placeholder?: string;
  hideMargin?: boolean;
  showClear?: boolean;
}

const SelectBox: React.FunctionComponent<ISelectBoxProps> = ({
  options,
  label,
  className,
  value,
  closeMenuOnSelect,
  onChange,
  isMulti = false,
  customStyles,
  placeholder,
  hideMargin = false,
  showClear = true,
}) => {
  const [isClearable, setIsClearable] = useState<boolean>(false);
  return (
    <div className={`${!hideMargin && 'mb-3'}`}>
      {label && <Label className="mb-1 text-start search-label">{label}</Label>}
      <div className={`close ${className}`}>
        <Select
          aria-label={label}
          styles={customStyles}
          isMulti={isMulti}
          closeMenuOnSelect={!closeMenuOnSelect ? closeMenuOnSelect : true}
          value={value}
          options={options}
          onChange={onChange}
          placeholder={placeholder}
          onFocus={() => {
            setIsClearable(true);
          }}
          onBlur={() => {
            setIsClearable(false);
          }}
          isClearable={!showClear ? false : isClearable}
        />
      </div>
    </div>
  );
};

export default SelectBox;
